class Colors {
  background: string = '#ffffff'
  blue: string = '#1890ff'
  primary: string = '#ff9d0b'
  gray: string = '#ededed'
  blueDark: string = '#111d5e'
}

export default new Colors()
